function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsPrivacyPolicy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icons/privacy policy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51107",
    d: "M15.606 18.414a.451.451 0 0 1-.177-.036C15.29 18.318 12 16.886 12 13.939v-2.415a.451.451 0 0 1 .306-.427l3.155-1.073a.451.451 0 0 1 .29 0l3.155 1.076a.451.451 0 0 1 .306.427v2.415c0 2.947-3.29 4.379-3.429 4.44a.461.461 0 0 1-.177.032zm-2.7-6.567v2.091c0 2 2.077 3.207 2.7 3.525.627-.317 2.7-1.522 2.7-3.525v-2.091l-2.7-.92z",
    transform: "translate(-4.212 -3.414)",
    style: {
      fill: "#868687"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51108",
    d: "M16.653 17.305a.447.447 0 0 1-.319-.132l-1.2-1.2a.451.451 0 0 1 .638-.638l.835.835 1.493-1.99a.451.451 0 1 1 .721.541l-1.8 2.4a.45.45 0 0 1-.329.179h-.031z",
    transform: "translate(-5.409 -5.15)",
    style: {
      fill: "#868687"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51109",
    d: "M6.365 13.2H1.653A1.693 1.693 0 0 1 0 11.469V1.728A1.693 1.693 0 0 1 1.653 0h6.911a1.693 1.693 0 0 1 1.653 1.728v3.413a.451.451 0 1 1-.9 0V1.728a.77.77 0 0 0-.753-.785H1.653a.77.77 0 0 0-.753.785v9.741a.77.77 0 0 0 .751.786h4.714a.472.472 0 0 1 0 .943z",
    style: {
      fill: "#868687"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51110",
    d: "M9.16 8.9H3.451a.451.451 0 0 1 0-.9H9.16a.451.451 0 0 1 0 .9z",
    transform: "translate(-1.197 -2.987)",
    style: {
      fill: "#868687"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51111",
    d: "M6.756 12.9H3.451a.451.451 0 1 1 0-.9h3.305a.451.451 0 1 1 0 .9z",
    transform: "translate(-1.197 -4.481)",
    style: {
      fill: "#868687"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51112",
    d: "M6.155 4.9h-2.7a.451.451 0 1 1 0-.9h2.7a.451.451 0 1 1 0 .9z",
    transform: "translate(-1.197 -1.494)",
    style: {
      fill: "#868687"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsPrivacyPolicy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons_privacy_policy.65fab3bea7b439f575e1488263599216.svg";